import React from 'react';

import { LoadRequestsTableBodyProps } from '@epi-models/pages/Reports';
import { LoadRequestsTableRow } from '../LoadRequestsTableRow';

export const LoadRequestsTableBody = ({
  loadRequests
}: LoadRequestsTableBodyProps) => {
  return (
    <>
      {loadRequests.map(loadRequest => (
        <LoadRequestsTableRow {...loadRequest} key={loadRequest.requestDate} />
      ))}
    </>
  );
};
